import {
  BedDouble,
  BookOpen,
  Box,
  Brain,
  Brush,
  CalendarDays,
  ChartNoAxesCombined,
  CircleDollarSign,
  ConciergeBell,
  Dumbbell,
  Earth,
  Gift,
  Handbag,
  Heater,
  Hotel,
  Landmark,
  Lightbulb,
  Luggage,
  LucideIcon,
  MonitorSmartphone,
  NotepadText,
  Package,
  PenLine,
  PlaneTakeoff,
  Refrigerator,
  Search,
  Sofa,
  Sparkles,
  SprayCan,
  TreePalm,
  TrendingUp,
  UtensilsCrossed,
  WashingMachine,
} from 'lucide-react';

export interface ToolIcon {
  icon: LucideIcon;
  flipHorizontal?: boolean;
}

export type ToolIconConfig = LucideIcon | ToolIcon;

export function isToolIconObject(config: ToolIconConfig): config is ToolIcon {
  return typeof config === 'object' && 'icon' in config;
}

export const FLIGHT_ICONS: ToolIconConfig[] = [
  CalendarDays,
  PlaneTakeoff,
  Earth,
  { icon: PlaneTakeoff, flipHorizontal: true },
];
export const HOTEL_ICONS: ToolIconConfig[] = [CalendarDays, Hotel, TreePalm, Luggage];
export const HOTEL_FILTER_ICONS: ToolIconConfig[] = [
  BedDouble,
  UtensilsCrossed,
  ConciergeBell,
  Sparkles,
];
export const VACATION_PACKAGE_ICONS: ToolIconConfig[] = [
  CalendarDays,
  PlaneTakeoff,
  Hotel,
  TreePalm,
  Luggage,
  { icon: PlaneTakeoff, flipHorizontal: true },
];
// TODO: replace with dedicated organized-trip icons when design provides them
export const ORGANIZED_TRIP_ICONS: ToolIconConfig[] = VACATION_PACKAGE_ICONS;
export const HOTEL_INFO_ICONS: ToolIconConfig[] = [
  BedDouble,
  UtensilsCrossed,
  Sparkles,
  Dumbbell,
  ConciergeBell,
];
export const KNOWLEDGE_ICONS: ToolIconConfig[] = [Search, NotepadText, Brain, Lightbulb];
export const PRODUCT_ICONS: ToolIconConfig[] = [
  Refrigerator,
  WashingMachine,
  MonitorSmartphone,
  Heater,
];
export const KETER_PRODUCT_ICONS: ToolIconConfig[] = [Sofa, Package, TreePalm, Box];
/** Finance icons for t19 fund-search trail steps. */
export const FUND_ICONS: ToolIconConfig[] = [
  ChartNoAxesCombined,
  Landmark,
  CircleDollarSign,
  TrendingUp,
];
export const BEAUTY_ICONS: ToolIconConfig[] = [SprayCan, Handbag, Brush, Gift];
export const TEXT_STEP_ICONS: ToolIconConfig[] = [PenLine, Sparkles, BookOpen];

/** Domain-neutral icons for activity-trail rows whose tool has no tenant-specific config. */
export const GENERIC_TOOL_ICONS: ToolIconConfig[] = [Search, Sparkles, Brain];
